// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FrownFilledSvg from "@ant-design/icons-svg/es/asn/FrownFilled";
import AntdIcon from '../components/AntdIcon';

var FrownFilled = function FrownFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FrownFilledSvg
  }));
};

FrownFilled.displayName = 'FrownFilled';
export default React.forwardRef(FrownFilled);